module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1017.c9f7b9ba.png";